import { AppStatus } from '@/redux'

import { passwordReset } from '@/features/Auth/session/views'

export const requestPasswordReset = async (email: string) => {
  AppStatus.set('loading')

  try {
    await passwordReset(email)

    setTimeout(() => {
      AppStatus.set('done')
    }, 2000)
  } catch (e) {
    AppStatus.set('idle')
    logger.error('Could not request a password reset', e, 'Auth')
    alert('There was an error during password reset')
  }
}
